export default __webpack_public_path__ + "f095604.png";